'use strict';

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _first = require('lodash/first');

var _first2 = _interopRequireDefault(_first);

var _filter = require('lodash/filter');

var _filter2 = _interopRequireDefault(_filter);

var _pull = require('lodash/pull');

var _pull2 = _interopRequireDefault(_pull);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _uuid = require('uuid');

var _reporter = require('../reporter');

var _reporter2 = _interopRequireDefault(_reporter);

var _applicationState = require('../../utils/applicationState');

var _parseUtils = require('../../utils/parseUtils');

var _parseUtils2 = _interopRequireDefault(_parseUtils);

var _adsSettings = require('../../utils/adsSettings');

var _adsSettings2 = _interopRequireDefault(_adsSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onCanShowAdsChange = function onCanShowAdsChange() {
  var _this = this;

  if (!_adsSettings2.default.canShowAds() && this.canShowAds) {
    (0, _forEach2.default)(this.slotArray, function (slot) {
      _this.clearSlot(slot);
      _this.releaseSlot(slot);
    });
  }
  this.canShowAds = _adsSettings2.default.canShowAds();
};

var fallbackNetworkController = {
  slotArray: [],
  init: function init() {
    // listen to ads enabled event changes
    this.canShowAds = _adsSettings2.default.canShowAds();
    (0, _applicationState.addStateChangeListener)(_applicationState.State.selectedGuideId, onCanShowAdsChange.bind(this));
    (0, _applicationState.addStateChangeListener)(_applicationState.State.playerStatus, onCanShowAdsChange.bind(this));
  },
  registerSlot: function registerSlot(slot) {
    this.slotArray.push(slot);
  },
  deregisterSlot: function deregisterSlot(slot) {
    var slotData = (0, _find2.default)(this.slotArray, ['elementId', slot.elementId]);
    (0, _pull2.default)(this.slotArray, slotData);
  },
  serveAd: function serveAd(slot) {
    var _this2 = this;

    return new Promise(function (resolve) {
      var options = (0, _applicationState.getState)(_applicationState.State.options);
      var bannerAdsEnabled = _parseUtils2.default.parseBool((0, _get2.default)(options, 'bannerads.enabled', true));

      if (!slot || !_adsSettings2.default.canShowAds() || !bannerAdsEnabled) {
        resolve();
        return;
      }

      var format = (0, _first2.default)((0, _filter2.default)(slot.formats, ['adProvider', 'fallback']));
      if (!format) {
        resolve();
        return;
      }

      slot.requestId = (0, _uuid.v4)().toString();
      _this2.renderFallback(slot, format);
      _reporter2.default.impression(slot);

      resolve();
    });
  },
  clearSlot: function clearSlot(slot) {
    if (slot) {
      var $slotEl = (0, _jquery2.default)('#' + slot.elementId);
      if ($slotEl) {
        $slotEl.empty();
        $slotEl.off();
      }
    }
  },
  releaseSlot: function releaseSlot() {},
  getAssetName: function getAssetName(format) {
    var fileName = 'fallback_' + format.dimensions[0][0] + 'x' + format.dimensions[0][1] + '.png';
    return (0, _applicationState.getState)(_applicationState.State.assetLocation) + 'assets/img/' + fileName;
  },
  renderFallback: function renderFallback(slot, format) {
    var src = this.getAssetName(format);
    var html = '<a href="/premium" target="_blank">';
    html += '<div style="width: ' + format.dimensions[0][0] + 'px;';
    html += ' height: ' + format.dimensions[0][1] + 'px;';
    html += ' background-image: url(\'' + src + '\'); display: inline-block;"></div></a>';
    (0, _jquery2.default)('#' + slot.elementId).html(html);
  }
};

module.exports = fallbackNetworkController;